import { Injectable, ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { environment } from '@env/environment';
import { AuthService } from './auth.service';


Sentry.init({
  enabled: true,
  release: environment.version,
  dsn: environment.sentryDsn,
  environment: environment.envName
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {

  constructor() { }

  handleError(error) {
    console.error(error);
    const currentUser: any =  JSON.parse(localStorage.getItem('eyrus-user')) || {};

    if (currentUser) {
      const user = currentUser.user || {};
      const account = currentUser.account || {};

      Sentry.setUser({
        email: user.email || '',
        userId: user.userId || '',
        userName: user.userName || '',
        name: (`${user.firstName} ${user.lastName}`).trim() || '---',
        account: account || []
      });
    }

    const eventId = Sentry.captureException(error.originalError || error);
    // Sentry.showReportDialog({ eventId });
  }

}
